@if (!readModeEnabled()) {
  @if (dynamicForm) {
    @let fields = dynamicForm?.value;
    <form [formGroup]="dynamicForm" class="mb-4">
      @if (!hideTitle()) {
        <div class="mb-2">
          <h3 class="text-xl font-normal mb-1 pb-0! mt-0">
            {{ fields.title || 'Nessun titolo' }}
          </h3>
          @if (fields.description) {
            <div class="text-sm font-normal">
              {{ fields.description }}
            </div>
          }
        </div>
      }

      <!-- Form semplice -->
      <div>
        @if (fields.sections?.length > 0) {
          @for (section of fields.sections; track section.id; let i = $index) {
            @let sectionFieldsGroup = getSectionFieldsGroup(i);

            <div formArrayName="sections">
              @if (!hideTitle()) {
                <h3 class="text-lg font-normal mb-1">
                  {{
                    section.title || 'Nessun titolo della sezione ' + (i + 1)
                  }}
                </h3>
                @if (section.description) {
                  <div class="text-sm font-normal">
                    {{ section.description }}
                  </div>
                }
              }
              @if (section.fields?.length > 0) {
                @if (formMode() === 'preview') {
                  <mat-card class="mb-2 mt-4 px-3 pb-3" appearance="outlined">
                    <mat-card-content class="p-0!">
                      <div
                        [formGroup]="sectionFieldsGroup"
                        class="mt-3 grid grid-cols-1 gap-3"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            sectionFields;
                            context: {
                              section: section,
                              index: i,
                            }
                          "
                        ></ng-container>
                      </div>
                    </mat-card-content>
                  </mat-card>
                } @else {
                  <div
                    [formGroup]="sectionFieldsGroup"
                    class="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        sectionFields;
                        context: {
                          section: section,
                          index: i,
                        }
                      "
                    ></ng-container>
                  </div>
                }
              }
            </div>
          }
        }
      </div>
    </form>
  }
  <ng-template
    #sectionFields
    let-section="section"
    let-fieldsArray="fieldsArray"
    let-index="index"
  >
    @for (field of section.fields; track field?.id; let fieldIndex = $index) {
      @let fieldFormGroup =
        fieldsArray
          ? getFieldGroupFromArray(fieldsArray, fieldIndex)
          : getFieldGroup(index, fieldIndex);
      @if (isFieldVisible(fieldFormGroup)) {
        @if (isScaleField(field.type)) {
          <siat-dynamic-scale
            class="col-span-full col-start-1"
            [parentForm]="fieldFormGroup"
            [scaleData]="field?.config"
            [formMode]="formMode()"
          ></siat-dynamic-scale>
        } @else {
          @switch (field.type) {
            @case ('moniser') {
              <siat-moniser-field
                class="grid-cols-3 grid col-span-full items-center"
                [parentForm]="fieldFormGroup"
                [label]="field.label"
                [placeholder]="field.placeholder"
              ></siat-moniser-field>
            }
            @case ('typology') {
              @let endpointValue = fieldFormGroup.get('endpoint')?.value;

              @if (!endpointValue) {
                <span class="text-error text-sm">
                  <b>ATTENZIONE:</b> Nessun endpoint selezionato per la lista
                  tipologica
                </span>
              } @else {
                <ng-container [formGroup]="fieldFormGroup">
                  <siat-items-list
                    class="col-span-full"
                    formControlName="value"
                    [queryParamName]="endpointValue?.id"
                    [label]="field.label"
                    [placeholder]="field.placeholder"
                  ></siat-items-list>
                </ng-container>
              }
            }
            @case ('email') {
              <siat-input-field
                type="email"
                class="col-span-1"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="
                  field.placeholder || 'Inserisci un indirizzo email'
                "
              ></siat-input-field>
            }
            @case ('codice-fiscale') {
              <siat-input-field
                type="text"
                class="col-span-1"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="
                  field.placeholder || 'Inserisci un codice fiscale'
                "
              ></siat-input-field>
            }
            @case ('telefono') {
              <siat-input-field
                type="text"
                class="col-span-1"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="
                  field.placeholder || 'Inserisci un numero di telefono'
                "
              ></siat-input-field>
            }
            @case ('regioni-province-comuni') {
              @let valueFormGroup = regProvComuneValueFg(fieldFormGroup);
              <siat-regioni-province-comuni
                class="grid grid-cols-1 gap-3 col-span-1 col-start-1"
                [parentFormgroup]="valueFormGroup"
                [regioniControlName]="'regione'"
                [provinciaControlName]="'provincia'"
                [comuneControlName]="'comune'"
              ></siat-regioni-province-comuni>
            }
            @case ('nazione') {
              <siat-select-tipologica-field
                [formGroup]="fieldFormGroup"
                controlName="value"
                [id]="'nazione'"
                [class]="field?.hasCondition ? 'col-span-2' : 'col-span-1'"
                [name]="'nazione'"
                [placeholder]="field.placeholder || 'Seleziona la nazione'"
                [label]="field.label || 'Nessuna label inserita'"
                endpoint="nazione"
                [areMultiselect]="false"
              >
              </siat-select-tipologica-field>
            }
            @case ('priority') {
              <siat-select-field
                [class]="field?.hasCondition ? 'col-span-2' : 'col-span-1'"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [items]="priorityOptions"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="field.placeholder || 'Seleziona la priorità'"
                [areDynamicField]="true"
              ></siat-select-field>
            }
            @case ('select') {
              <siat-select-field
                [class]="field?.hasCondition ? 'col-span-2' : 'col-span-1'"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [showLabel]="true"
                [items]="field.options"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="field.placeholder || 'Effettua una selezione'"
                [areDynamicField]="true"
              ></siat-select-field>
            }
            @case ('text') {
              <siat-input-field
                [class]="field?.hasCondition ? 'col-span-2' : 'col-span-1'"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="field.placeholder || 'Risposta testuale corta'"
              ></siat-input-field>
            }
            @case ('number') {
              <siat-input-field
                type="number"
                [class]="field?.hasCondition ? 'col-span-2' : 'col-span-1'"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="
                  field.max
                    ? 'Inserisci un valore compreso tra ' +
                      field.min +
                      ' e ' +
                      field.max
                    : 'Inserisci un valore superiore a ' + field.min
                "
              ></siat-input-field>
            }
            @case ('checkbox') {
              <div class="col-span-2">
                @let optionsControl = fieldFormGroup.get('options');
                @let isInvalid =
                  fieldFormGroup?.invalid &&
                  (fieldFormGroup?.touched || fieldFormGroup?.dirty);
                @let hasCheckboxError =
                  field.required &&
                  optionsControl?.hasError('atLeastOneCheckboxIsChecked') &&
                  optionsControl?.touched;

                <label
                  [for]="field?.id"
                  [ngClass]="{ 'text-error!': isInvalid }"
                  class="flex items-center gap-1"
                >
                  {{ field.label || 'Nessuna label inserita' }}

                  @if (
                    field.required ||
                    optionsControl?.hasError('atLeastOneCheckboxIsChecked')
                  ) {
                    <span class="font-bold">*</span>
                  }
                </label>

                @if (field?.options?.length > 0) {
                  <div class="flex flex-col mt-2">
                    @for (
                      option of field.options;
                      track option?.id;
                      let optIndex = $index
                    ) {
                      <siat-checkbox-field
                        [formGroup]="getOptionsGroup(fieldFormGroup, optIndex)"
                        [controlName]="'selected'"
                        [label]="option.name"
                        [belongsToGroup]="true"
                      ></siat-checkbox-field>
                    }
                  </div>

                  @if (hasCheckboxError) {
                    <span class="text-xs text-error mt-1">
                      Seleziona almeno un'opzione.
                    </span>
                  }
                }
              </div>
            }
            @case ('textarea') {
              <siat-textarea-field
                [class]="'col-span-2'"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [name]="field?.label"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="field.placeholder || 'Risposta testuale lunga'"
              ></siat-textarea-field>
            }
            @case ('toggle') {
              <siat-switch-field
                [class]="field?.hasCondition ? 'col-span-2' : 'col-span-1'"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
              ></siat-switch-field>
            }
            @case ('radiobutton') {
              <siat-radio-field
                class="col-span-2"
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
                [displayInline]="true"
                [data]="field.options"
                [areDynamicField]="true"
              ></siat-radio-field>
            }
            @case ('uploadfile') {
              <div class="col-span-full" [formGroup]="fieldFormGroup">
                <siat-upload-file
                  [label]="field.label || 'Nessuna label inserita'"
                  [placeholder]="
                    field.placeholder || 'Trascina e rilascia un file qui'
                  "
                  formControlName="value"
                  [previewResolver]="resolvePreview"
                  (onDelete)="onDeleteFile($event, fieldFormGroup.get('value'))"
                >
                </siat-upload-file>
              </div>
            }
            @case ('accordion') {
              <mat-accordion class="col-span-full" [multi]="true">
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ field.label || 'Nessuna label inserita' }}
                    </mat-panel-title>
                    @if (field.placeholder) {
                      <mat-panel-description>
                        {{ field.placeholder }}
                      </mat-panel-description>
                    }
                  </mat-expansion-panel-header>

                  @let accordionFieldsArray =
                    getAccordionFieldsArray(fieldFormGroup);

                  <div
                    [formGroup]="$any(accordionFieldsArray)"
                    class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-3"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        sectionFields;
                        context: {
                          section: { fields: field.fields || [] },
                          fieldsArray: accordionFieldsArray,
                        }
                      "
                    ></ng-container>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            }
            @case ('date') {
              <siat-datepicker-field
                [formGroup]="fieldFormGroup"
                [controlName]="'value'"
                [label]="field.label || 'Nessuna label inserita'"
                [placeholder]="'Seleziona una data'"
                class="col-span-1"
              ></siat-datepicker-field>
            }

            @default {
              <p class="text-red-600">Tipo sconosciuto: {{ field.type }}</p>
            }
          }
        }
      }
    }
  </ng-template>
} @else {
  <h3 class="text-xl mb-1 font-semibold pb-0! mt-4 mx-3">
    {{ fieldValuesToRead()?.title | uppercase }}
  </h3>
  @if (fieldValuesToRead()?.description) {
    <p class="text-sm font-normal mt-0 mx-3">
      {{ fieldValuesToRead()?.description }}
    </p>
  }

  @for (section of fieldValuesToRead()?.sections; track section?.title) {
    <div class="section-group mb-3 mx-3">
      <h4 class="font-semibold mb-1 mt-1">
        {{ section?.title }}
      </h4>
      @if (section.description) {
        <p class="text-sm font-normal mt-0 mb-2">
          {{ section?.description }}
        </p>
      }

      <ng-container
        *ngTemplateOutlet="
          readFields;
          context: {
            fields: section?.fields,
          }
        "
      ></ng-container>
    </div>
  }

  <ng-template #readFields let-fields="fields">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-1 pb-3">
      @for (field of fields; track field?.id) {
        @if (field?.type === 'accordion') {
          <mat-accordion class="col-span-full" [multi]="true">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>{{ field?.description }}</mat-panel-title>
                @if (field?.value) {
                  <mat-panel-description>
                    {{ field?.value }}
                  </mat-panel-description>
                }
              </mat-expansion-panel-header>

              <ng-container
                *ngTemplateOutlet="
                  readFields;
                  context: {
                    fields: field?.fields || [],
                  }
                "
              ></ng-container>
            </mat-expansion-panel>
          </mat-accordion>
        } @else if (field?.type !== 'uploadfile') {
          <div class="col-span-full">
            <span class="font-normal text-sm"> {{ field?.description }}: </span>
            <span class="font-semibold text-sm">
              @if (field?.type === 'date' && field?.value) {
                {{ $any(field.value) | date: 'dd/MM/yyyy' }}
              } @else {
                {{ field?.value || 'N/A' }}
              }
            </span>
          </div>
        } @else {
          <div class="col-span-auto">
            <span class="font-semibold flex flex-row items-center">
              {{ field?.description }}:
              @if (field?.value) {
                <siat-upload-file
                  [readonly]="true"
                  [previewResolver]="resolvePreview"
                  [value]="getFileValues(field?.value)"
                ></siat-upload-file>
              }
            </span>
          </div>
        }
      }
    </div>
  </ng-template>
}
